// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetCaseResponseModel {
    static getAttributeTypeMap() {
        return GetCaseResponseModel.attributeTypeMap;
    }
}
GetCaseResponseModel.discriminator = undefined;
GetCaseResponseModel.attributeTypeMap = [
    {
        "name": "accountData",
        "baseName": "accountData",
        "type": "AccountModel"
    },
    {
        "name": "caseData",
        "baseName": "caseData",
        "type": "CaseModel"
    },
    {
        "name": "patientData",
        "baseName": "patientData",
        "type": "PatientModel"
    },
    {
        "name": "diagnosisData",
        "baseName": "diagnosisData",
        "type": "Array<DiagnosisModel>"
    },
    {
        "name": "payorData",
        "baseName": "payorData",
        "type": "Array<GetCasePayorResponseModel>"
    },
    {
        "name": "pharmacyData",
        "baseName": "pharmacyData",
        "type": "Array<GetCasePharmacyResponseModel>"
    },
    {
        "name": "prescriberData",
        "baseName": "prescriberData",
        "type": "Array<PrescriberModel>"
    },
    {
        "name": "prescriptionData",
        "baseName": "prescriptionData",
        "type": "Array<PrescriptionModel>"
    },
    {
        "name": "siteData",
        "baseName": "siteData",
        "type": "Array<GetCaseSiteResponseModel>"
    },
    {
        "name": "surveyData",
        "baseName": "surveyData",
        "type": "Array<GetCaseSurveyResponseModel>"
    },
    {
        "name": "ssn",
        "baseName": "ssn",
        "type": "string"
    }
];
//# sourceMappingURL=getCaseResponseModel.js.map